import lodash from 'lodash';
import MatchEvent from '../interfaces/matchEvent';
import { MatchEventType } from '../enums/matchEventType';
import MatchEventPayload from '../interfaces/matchEventPayload';

export default function (matchEvent: MatchEvent): MatchEventPayload {
  const response: any = lodash.clone(matchEvent);

  if (response.team) {
    response.team = { id: response.team.id };
  }

  if (response.person) {
    response.person = {
      id: response.person.personId ?? response.person.id,
    };
  }

  if (response.internal) delete response.internal;
  if (
    response.sorting &&
    ![MatchEventType.PENALTY_SAVE, MatchEventType.PENALTY_GOAL, MatchEventType.PENALTY_MISS].includes(
      response.matchEventTypeId,
    )
  ) {
    delete response.sorting;
  }

  delete response.timeRounded;
  delete response.overtimeRounded;
  delete response.periodSorting;
  delete response.type;
  delete response.uid;
  delete response.sportId;

  return response;
}
